<template>
  <standard-layout>
    <template v-slot:main>
      <div class="h5 mt-3">Bestellungen, Reservierungen</div>
      <div class="list-group">
        <ExplainedLinkListItem to="reservationCalendar" title="Reservierungskalender"
                               description="Schau Dir Reservierungen an oder blockiere Tage"/>
        <ExplainedLinkListItem to="newReservation" title="Neue Reservierung"
                               description="Erfasse eine neue Reservierung."/>
        <ExplainedLinkListItem to="newOrder" title="Bestellung eines Standard-Produktes"
                               description="Erfasse eine neue Bestellung eines Standardproduktes."/>
        <ExplainedLinkListItem to="newOrderXTR" title="Extra Bestellung"
                               description="Erfasse eine neue Bestellung eines beliebigen Produktes oder erfasse ein Storno."/>
        <ExplainedLinkListItem to="subscriptions" title="Benachrichtigungsliste"
                               description="Erstelle neue Einträge, um Kunden über frei gewordene Termine zu informieren"/>
        <ExplainedLinkListItem to="voucherGenerator" title="Gutschein generieren"
                               description="Erstelle einen Gutschein für einen Kunden ohne Rechnung. Zum Beispiel für Insta-Poster"/>
      </div>
      <div class="h5 mt-3">Steuer</div>
      <ExplainedLinkListItem to="taxes" title="Umsatzsteuer"
                             description="Liste aller Verkäufe für die Steuer"/>
      <div class="h5 mt-3">Administration</div>
      <div class="list-group">
        <ExplainedLinkListItem to="listProducts" title="Produkte bearbeiten"
                               description="Erstelle neue Produkte oder passe die bestehenden an."/>
        <ExplainedLinkListItem to="productAvailabilities" title="Produktverfügbarkeiten"
                               description="Wann kann welches Produkt noch gebucht werden?"/>
        <ExplainedLinkListItem to="bulkEditArticles" title="Preise bearbeiten"
                               description="Erstelle neue Verkaufsartikel oder bearbeite bestehende."/>
        <ExplainedLinkListItem to="operatingMode" title="Operations-Modus"
                               description="Lege für jeden Kalendertag den Betriebsmodus fest (Single, Solo, Parallel)."/>

      </div>
      <div class="h5 mt-5">Experten-Funktionen</div>
      <div class="btn btn-sm btn-success mr-1"
           @click="triggerGoogleCalendarSync">
        Trigger Google Calendar Sync
      </div>
      <div class="btn btn-sm btn-success mr-1"
           @click="triggerGoogleContactsSync">
        Trigger Google Kontakte Sync
      </div>
      <div class="btn btn-sm btn-success mr-1"
           @click="triggerVoucherPriceSync">
        Gutschein-Preise syncen
      </div>
      <div class="btn btn-sm btn-warning mr-1"
           @click="triggerReservationPreInformation">
        Trigger Versand von Vorabinformationen
      </div>
      <div class="btn btn-sm btn-warning mr-1"
           @click="triggerExpirationCheck">
        Trigger Expiration Cck
      </div>
      <div class="btn btn-sm btn-success mr-1"
           @click="triggerOrderPurge">
        Trigger Order Purge
      </div>
    </template>
  </standard-layout>
</template>
<script>
import StandardLayout from "@/layouts/StandardLayout";
import ExplainedLinkListItem from "@/components/components/ExplainedLinkListItem.vue";

export default {
  data() {
    return {
      selectedOrder: undefined
    }
  },
  methods: {
    triggerReservationPreInformation() {
      this.$api.post("/admin/trigger-reservation-pre-information")
          .then(() => this.showInfo("Vorabinformationen wurden versendet."))
          .catch(err => this.handleError(err))
    },
    triggerExpirationCheck() {
      this.$api.post("/admin/trigger-expiration-check")
          .then((res) => this.showInfo(res.data + ' Reservierungen wurden gecanceled.'))
          .catch(err => this.handleError(err))
    },
    triggerGoogleCalendarSync() {
      this.$api.post("/tools/google-calendar/sync")
          .then(() => this.showInfo("Google Calendar Sync beendet."))
          .catch(err => this.handleError(err))
    },
    triggerGoogleContactsSync() {
      this.$api.post("/tools/google-contacts/sync")
          .then(() => this.showInfo("Google Kontakte Sync beendet."))
          .catch(err => this.handleError(err))
    },
    triggerVoucherPriceSync() {
      this.$api.post("/tools/voucher-price-sync")
          .then(() => this.showInfo("Gutscheinpreise wurden gesynct."))
          .catch(err => this.handleError(err))
    },
    triggerOrderPurge() {
      this.$api.post(`/admin/purge-orders`)
          .then(() => {
            this.showInfo("Orders deleted.")
            this.$emit('update')
          }).catch(err => this.handleError(err))
    }
  },
  components: {ExplainedLinkListItem, StandardLayout}
}
</script>

<style>
a {
  display: block;
}
</style>
